import { gql } from '@apollo/client';

export const INSIGHT_ASSIGNEE_FIELDS_FRAGMENT = gql`
  fragment InsightAssigneeFields on Insight {
    assignee {
      ... on Team {
        id
        name
      }
      ... on User {
        id
        displayName
        username
        email
      }
      ... on UnknownUser {
        username
      }
      ... on UnknownTeam {
        name
      }
    }
  }
`;

export const INSIGHT_SIGNAL_FIELDS_FRAGMENT = gql`
  fragment InsightSignalFields on Signal {
    contentType
    id
    name
    severity
    timestamp
  }
`;

export const ENTITY_FIELDS_FRAGMENT = gql`
  fragment EntityFieldsFragment on EntityInterface {
    id
    criticality
    entityType
    entityTypeName
    value
    sensorZone
    # don't add reputation fields here as they will not resolve when used in bulk queries
  }
`;

export const KEY_EVIDENCE_FIELDS_FRAGMENT = gql`
  fragment KeyEvidenceFields on KeyEvidence {
    id
    title
    reasoning
    verdict
  }
`;

export const INSIGHT_TRIAGE_FIELDS_FRAGMENT = gql`
  fragment InsightTriageFields on Triage {
    id
    insightID
    verdict
    summary
    recommendation {
      accepted
      severity
    }
    keyEvidences {
      ...KeyEvidenceFields
    }
  }
  ${KEY_EVIDENCE_FIELDS_FRAGMENT}
`;

export const INSIGHT_FIELDS_FRAGMENT = gql`
  fragment InsightFields on Insight {
    ...InsightAssigneeFields
    deployment
    tenant
    tenantName
    tenantUrl
    created
    description
    entity {
      ...EntityFieldsFragment
      isWhitelisted
    }
    id
    readableId
    relatedIncidents {
      id
      name
      type
      link
      status
      assignee
    }
    name
    signalCount
    uniqueSignalCount
    severity
    confidence
    signals {
      ...InsightSignalFields
    }
    resolution
    summary @include(if: $enableAIInsightSummary)
    subResolution
    tags
    status {
      id
      name
      displayName
    }
    lastUpdated
    timestamp
    source
    triage @include(if: $enableAgenticSecOps) {
      ...InsightTriageFields
    }
  }
  ${INSIGHT_ASSIGNEE_FIELDS_FRAGMENT}
  ${INSIGHT_SIGNAL_FIELDS_FRAGMENT}
  ${ENTITY_FIELDS_FRAGMENT}
  ${INSIGHT_TRIAGE_FIELDS_FRAGMENT}
`;